import Image from "next/image"
import React from "react"
import { getStaticFile } from "utils/getStaticFile"

type Props = {
  src: string
  title: string
  alt: string
}

export const QuizImage: React.FC<Props> = (props) => {
  return (
    <Image
      {...props}
      fill
      placeholder="blur"
      blurDataURL={getStaticFile("/images/placeholder.svg")}
      priority
      style={{
        objectPosition: "0% 30%",
        objectFit: "cover",
      }}
    />
  )
}
